module.exports = __webpack_public_path__ + "img/logo-loto-hotpicks-2x.9e77ea0e.jpg";